import React, {Fragment} from 'react';
import {Grid} from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelAutoCompleteInput,
  SideLabelMoneyWithRefInput,
  SecuritizedInput
 } from '../../FormSectionComponents';  

class PrepaymentTermsYieldMaintenance extends React.Component {  

  renderSecuritizedInput = (formik) => {
    let dateComponents = formik.values.prepaymentTerms.securitizationDate ? formik.values.prepaymentTerms.securitizationDate.split("-") : '';
    if(dateComponents[1] && !formik.values.prepaymentTerms.securitizationMonth){
      formik.setFieldValue("prepaymentTerms.securitizationMonth",(dateComponents[1]-1).toString(),false);
      formik.setFieldValue("prepaymentTerms.securitizationYear",dateComponents[0],false);
    }
    return(
      <SecuritizedInput 
        formk={formik}
        label="Securitization"
        checkboxFieldName="Securitized "
        midLabel="Month: "
        isSecuritized={formik.values.prepaymentTerms.isSecuritized}
        securitizationDate={formik.values.prepaymentTerms.securitizationDate}
        isDisabled = {!this.props.isEditing}
        onChange = {(o) => {
          this.setState(o);
        }}
      />
    )
  }


  render(){    
    const {isEditing, formik} = this.props;
    return (
      <Fragment>
         <SideLabelPercentWithRefInput
          label="Exit Fee"
          hasBorder
          placeholder="Exit Fee"
          fieldName="prepaymentTerms.exitFee"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Lockout Period"
          hasBorder
          placeholder="Lockout Period"
          fieldName="prepaymentTerms.lockoutPeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Par Prepayment Period"
          hasBorder
          placeholder="Par Prepayment Period"
          fieldName="prepaymentTerms.parPrepaymentPeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Notice Period"
          hasBorder
          placeholder="Notice Period"
          fieldName="prepaymentTerms.noticePeriod"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Yield Maintenance Period"
          hasBorder
          placeholder="Yield Maintenance Period"
          fieldName="prepaymentTerms.yieldMaintenancePeriod"
          isDisabled={!isEditing}/>          
        <SideLabelTextAreaWithRefInput
          label="Calculation Methodology"
          hasBorder
          placeholder="Calculation Methodology"
          fieldName="prepaymentTerms.calculationMethodology"
          isDisabled={!isEditing}/>  
        <SideLabelTextAreaWithRefInput
          label="Reinvestment Rate Assumptions"
          hasBorder
          placeholder="Reinvestment Rate Assumptions"
          fieldName="prepaymentTerms.reinvestmentRateAssumption"
          isDisabled={!isEditing}/>   
          {this.renderSecuritizedInput(formik)} 
        <SideLabelTextAreaWithRefInput
          label="Other"
          placeholder="Other"
          fieldName="prepaymentTerms.other"
          isDisabled={!isEditing}/>  
      </Fragment>
  )};
}
export default PrepaymentTermsYieldMaintenance;